import { SettingItemTypes } from '../constants';

export const SETTINGS_STORAGE_PREFIX = 'settings.';

// this should be in sync with the settings keys defined in the config
export enum KnownSettings {
  Ccpa = 'ccpa',
  AutoPlay = 'autoPlay',
}

export type SettingsKey = KnownSettings | string;

export const serializableItemTypes: string[] = [
  SettingItemTypes.SELECT,
  SettingItemTypes.CHECKBOX,
];
